/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NamespacesImport } from './routes/namespaces'
import { Route as KeysImport } from './routes/keys'
import { Route as IndexImport } from './routes/index'
import { Route as KeysNamespaceIdImport } from './routes/keys.$namespaceId'
import { Route as KeysNamespaceIdKeyImport } from './routes/keys.$namespaceId.$key'

// Create/Update Routes

const NamespacesRoute = NamespacesImport.update({
  id: '/namespaces',
  path: '/namespaces',
  getParentRoute: () => rootRoute,
} as any)

const KeysRoute = KeysImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const KeysNamespaceIdRoute = KeysNamespaceIdImport.update({
  id: '/$namespaceId',
  path: '/$namespaceId',
  getParentRoute: () => KeysRoute,
} as any)

const KeysNamespaceIdKeyRoute = KeysNamespaceIdKeyImport.update({
  id: '/$key',
  path: '/$key',
  getParentRoute: () => KeysNamespaceIdRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/keys': {
      id: '/keys'
      path: '/keys'
      fullPath: '/keys'
      preLoaderRoute: typeof KeysImport
      parentRoute: typeof rootRoute
    }
    '/namespaces': {
      id: '/namespaces'
      path: '/namespaces'
      fullPath: '/namespaces'
      preLoaderRoute: typeof NamespacesImport
      parentRoute: typeof rootRoute
    }
    '/keys/$namespaceId': {
      id: '/keys/$namespaceId'
      path: '/$namespaceId'
      fullPath: '/keys/$namespaceId'
      preLoaderRoute: typeof KeysNamespaceIdImport
      parentRoute: typeof KeysImport
    }
    '/keys/$namespaceId/$key': {
      id: '/keys/$namespaceId/$key'
      path: '/$key'
      fullPath: '/keys/$namespaceId/$key'
      preLoaderRoute: typeof KeysNamespaceIdKeyImport
      parentRoute: typeof KeysNamespaceIdImport
    }
  }
}

// Create and export the route tree

interface KeysNamespaceIdRouteChildren {
  KeysNamespaceIdKeyRoute: typeof KeysNamespaceIdKeyRoute
}

const KeysNamespaceIdRouteChildren: KeysNamespaceIdRouteChildren = {
  KeysNamespaceIdKeyRoute: KeysNamespaceIdKeyRoute,
}

const KeysNamespaceIdRouteWithChildren = KeysNamespaceIdRoute._addFileChildren(
  KeysNamespaceIdRouteChildren,
)

interface KeysRouteChildren {
  KeysNamespaceIdRoute: typeof KeysNamespaceIdRouteWithChildren
}

const KeysRouteChildren: KeysRouteChildren = {
  KeysNamespaceIdRoute: KeysNamespaceIdRouteWithChildren,
}

const KeysRouteWithChildren = KeysRoute._addFileChildren(KeysRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/keys': typeof KeysRouteWithChildren
  '/namespaces': typeof NamespacesRoute
  '/keys/$namespaceId': typeof KeysNamespaceIdRouteWithChildren
  '/keys/$namespaceId/$key': typeof KeysNamespaceIdKeyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/keys': typeof KeysRouteWithChildren
  '/namespaces': typeof NamespacesRoute
  '/keys/$namespaceId': typeof KeysNamespaceIdRouteWithChildren
  '/keys/$namespaceId/$key': typeof KeysNamespaceIdKeyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/keys': typeof KeysRouteWithChildren
  '/namespaces': typeof NamespacesRoute
  '/keys/$namespaceId': typeof KeysNamespaceIdRouteWithChildren
  '/keys/$namespaceId/$key': typeof KeysNamespaceIdKeyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/keys'
    | '/namespaces'
    | '/keys/$namespaceId'
    | '/keys/$namespaceId/$key'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/keys'
    | '/namespaces'
    | '/keys/$namespaceId'
    | '/keys/$namespaceId/$key'
  id:
    | '__root__'
    | '/'
    | '/keys'
    | '/namespaces'
    | '/keys/$namespaceId'
    | '/keys/$namespaceId/$key'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KeysRoute: typeof KeysRouteWithChildren
  NamespacesRoute: typeof NamespacesRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KeysRoute: KeysRouteWithChildren,
  NamespacesRoute: NamespacesRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/keys",
        "/namespaces"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/keys": {
      "filePath": "keys.tsx",
      "children": [
        "/keys/$namespaceId"
      ]
    },
    "/namespaces": {
      "filePath": "namespaces.tsx"
    },
    "/keys/$namespaceId": {
      "filePath": "keys.$namespaceId.tsx",
      "parent": "/keys",
      "children": [
        "/keys/$namespaceId/$key"
      ]
    },
    "/keys/$namespaceId/$key": {
      "filePath": "keys.$namespaceId.$key.tsx",
      "parent": "/keys/$namespaceId"
    }
  }
}
ROUTE_MANIFEST_END */
